export enum ParticipantActionButtonDataHooks {
  ADD = 'add-participant-button',
  REMOVE = 'remove-participant-button',
  TOOLTIP = 'participant-action-button-tooltip',
}
